import { ChatContext } from "contexts/ChatContext"
import { useContext } from "react"

const useChat = () => useContext(ChatContext)

export default useChat
